import { l as lazyInit } from "./utilities-2Suih3Nm.js";
class TabGroup extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    lazyInit(this, () => this.init());
  }
  init() {
    const itemListContainer = this.querySelector("[data-tab-item-list-content-inner]");
    const tabItems = this.querySelectorAll("[data-tab-item]");
    const tabButtons = this.querySelectorAll("[data-tab-button]");
    if (!itemListContainer || tabItems.length === 0 || tabButtons.length === 0) return;
    this.indicator = itemListContainer.querySelector(".til-indicator");
    this.tabItems = tabItems;
    tabButtons.forEach((btn, index) => {
      var _a;
      const label = ((_a = tabItems[index]) == null ? void 0 : _a.dataset.label) || "";
      btn.addEventListener("click", () => {
        this.setActiveTab(index, tabItems, itemListContainer, label);
      });
      btn.addEventListener("keydown", (e) => {
        const currentIndex = index;
        let newIndex = currentIndex;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") {
          e.preventDefault();
          newIndex = (currentIndex + 1) % tabButtons.length;
        } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
          e.preventDefault();
          newIndex = (currentIndex - 1 + tabButtons.length) % tabButtons.length;
        } else if (e.key === "Home") {
          e.preventDefault();
          newIndex = 0;
        } else if (e.key === "End") {
          e.preventDefault();
          newIndex = tabButtons.length - 1;
        } else if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.setActiveTab(index, tabItems, itemListContainer, label);
          return;
        }
        if (newIndex !== currentIndex) {
          tabButtons[newIndex].focus();
          this.setActiveTab(newIndex, tabItems, itemListContainer, tabItems[newIndex].dataset.label);
        }
      });
    });
    if (tabItems.length > 0 && !this.classList.contains("js-ready")) {
      this.extractTemplate(tabItems[0]);
      tabItems[0].classList.add("active");
    }
    this.classList.add("js-ready");
    if (this.indicator) {
      const ro = new ResizeObserver(() => {
        this.updateIndicator(itemListContainer);
        ro.disconnect();
      });
      ro.observe(itemListContainer);
    }
  }
  updateIndicator(container) {
    const indicator = this.indicator;
    if (!indicator) return;
    const activeBtn = container.querySelector(".tab-button.active");
    if (!activeBtn) {
      indicator.style.opacity = "0";
      return;
    }
    const containerRect = container.getBoundingClientRect();
    const btnRect = activeBtn.getBoundingClientRect();
    const left = btnRect.left - containerRect.left + container.scrollLeft;
    const right = containerRect.width - left - btnRect.width;
    indicator.style.left = left + "px";
    indicator.style.right = right + "px";
    indicator.style.opacity = "1";
  }
  setActiveTab(activeIndex, tabItems, itemListContainer, label) {
    const container = this.querySelector("[data-tabs-content-inner]");
    if (!container) return;
    const startHeight = container.getBoundingClientRect().height;
    const listContainer = itemListContainer || this.querySelector("[data-tab-item-list-content-inner]");
    let navBtn = null;
    if (listContainer) {
      const buttons = listContainer.querySelectorAll("[data-tab-button]");
      navBtn = buttons[activeIndex];
      if (navBtn && navBtn.classList.contains("active")) return;
      buttons.forEach((btn, index) => {
        const isActive = index === activeIndex;
        btn.classList.toggle("active", isActive);
        btn.setAttribute("aria-selected", isActive.toString());
        btn.setAttribute("tabindex", isActive ? "0" : "-1");
      });
    }
    tabItems.forEach((item, index) => {
      const isActive = index === activeIndex;
      if (isActive) this.extractTemplate(item);
      item.classList.toggle("active", isActive);
    });
    container.style.height = "auto";
    requestAnimationFrame(() => {
      const targetHeight = container.getBoundingClientRect().height;
      if (listContainer) {
        let targetScrollLeft = null;
        if (navBtn) {
          const containerRect = listContainer.getBoundingClientRect();
          const btnRect = navBtn.getBoundingClientRect();
          const btnCenter = btnRect.left - containerRect.left + listContainer.scrollLeft + btnRect.width / 2;
          targetScrollLeft = btnCenter - containerRect.width / 2;
        }
        this.updateIndicator(listContainer);
        if (targetScrollLeft !== null) {
          listContainer.scrollTo({ left: targetScrollLeft, behavior: "smooth" });
        }
      }
      if (Math.abs(startHeight - targetHeight) > 0.5) {
        container.animate(
          [{ height: startHeight + "px" }, { height: targetHeight + "px" }],
          { duration: 300, easing: "ease", fill: "none" }
        ).onfinish = () => {
          container.style.height = null;
        };
      } else {
        container.style.height = null;
      }
    });
  }
  extractTemplate(tabItem) {
    if (!tabItem) return;
    const template = tabItem.querySelector("template[data-tab-template]");
    if (template) {
      tabItem.appendChild(template.content.cloneNode(true));
      template.remove();
    }
  }
}
if (!customElements.get("tab-group")) {
  customElements.define("tab-group", TabGroup);
}
